import type { Components } from '@mui/material/styles';

export default function MuiStepLabel(): Components['MuiStepLabel'] {
  return {};
}
